/**
 * PII detection patterns for sanitization.
 *
 * Used by both PostHog and Sentry sanitizers to strip or mask
 * personally identifiable information before transmission.
 *
 * See Part 22 §125 of the Tech Guidelines.
 */

export const PII_PATTERNS = {
  /** Email addresses */
  EMAIL: /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g,

  /** Phone numbers (international and domestic formats) */
  PHONE: /(\+\d{1,3}[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}/g,

  /** US Social Security Numbers */
  SSN: /\b\d{3}[-]?\d{2}[-]?\d{4}\b/g,

  /** Credit card numbers (4 groups of 4 digits) */
  CREDIT_CARD: /\b\d{4}[-\s]?\d{4}[-\s]?\d{4}[-\s]?\d{4}\b/g,

  /** Passport numbers (1-2 letters followed by 6-9 digits) */
  PASSPORT: /\b[A-Z]{1,2}\d{6,9}\b/g,

  /** Dutch BSN (Citizen Service Number — 9 digits) */
  BSN: /\b\d{9}\b/g,
} as const;

export type PIIType = keyof typeof PII_PATTERNS;

/**
 * Keys that should always be stripped from event properties or Sentry extras.
 */
export const SENSITIVE_KEYS = [
  'password',
  'token',
  'secret',
  'apiKey',
  'api_key',
  'authorization',
  'accessToken',
  'access_token',
  'refreshToken',
  'refresh_token',
  'creditCard',
  'credit_card',
  'ssn',
  'bsn',
] as const;
